<div class="page permisos">
    <app-page-header titulo="Permisos de Censo" icono="bi-shield-lock-fill" seccion="admin"
        descripcion="Los permisos se conceden a cargos de la Federación. Una persona los tiene mientras ostente ese cargo en el ejercicio vigente, y solo si lo ostenta en una asociación institucional (permisos globales) o en la propia asociación (permisos de asociación).">
        <button type="button" class="btn btn-outline-secondary" (click)="cargar()" [disabled]="cargando">
            <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Actualizar
        </button>
    </app-page-header>

    @if (cargando) {
        <app-spinner [fullscreen]="false"></app-spinner>
    } @else if (error) {
        <div class="state-panel state-panel--error" role="alert">
            <i class="bi bi-exclamation-octagon-fill state-panel__icon" aria-hidden="true"></i>
            <p class="state-panel__text">{{ error }}</p>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="cargar()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
        </div>
    } @else {
        <div class="alert alert-info" role="note">
            <strong>Cómo se usa.</strong> Despliega un cargo, elige el alcance de cada permiso y pulsa «Guardar».
            Los cambios sensibles piden confirmación y quedan registrados con tu nombre y la fecha.
            Siempre debe quedar al menos una persona con el permiso «permisos:gestionar»; si un cambio lo impide, se rechaza.
            @if (administradoresVigentes !== null) {
                <span class="badge text-bg-light ms-1">Administradores de permisos vigentes: {{ administradoresVigentes }}</span>
            }
        </div>

        <section class="panel" aria-labelledby="titulo-institucionales">
            <h2 id="titulo-institucionales" class="panel__title">Asociaciones institucionales</h2>
            <p class="panel__lead">
                Un cargo solo concede permisos <strong>globales</strong> cuando se ostenta en una de estas asociaciones.
                Un cargo de una foguera o barraca nunca concede permisos globales, aunque se llame igual.
            </p>
            @if (institucionales.length === 0) {
                <div class="alert alert-warning">Aún no hay ninguna asociación institucional: nadie tiene permisos globales.</div>
            } @else {
                <ul class="list-group mb-3">
                    @for (item of institucionales; track item.id) {
                        <li class="list-group-item d-flex justify-content-between align-items-center gap-2">
                            <span><i class="bi bi-building me-2 text-muted" aria-hidden="true"></i>{{ item.nombre || ('Asociación #' + item.id) }}</span>
                            <button type="button" class="btn btn-outline-danger btn-sm" [attr.aria-label]="'Quitar ' + (item.nombre || ('asociación ' + item.id)) + ' de las institucionales'" (click)="quitarInstitucional(item)"><i class="bi bi-x-lg" aria-hidden="true"></i>Quitar</button>
                        </li>
                    }
                </ul>
            }
            <div class="input-group">
                <label class="input-group-text" for="nueva-institucional">Añadir</label>
                <select id="nueva-institucional" class="form-select" [(ngModel)]="nuevaInstitucional">
                    <option [ngValue]="null">Elige una asociación…</option>
                    @for (item of disponiblesParaAnadir(); track item.id) {
                        <option [ngValue]="item.id">{{ item.nombre }}</option>
                    }
                </select>
                <button type="button" class="btn btn-primary" [disabled]="!nuevaInstitucional" (click)="anadirInstitucional()">Añadir</button>
            </div>
        </section>

        <section class="panel" aria-labelledby="titulo-cargos">
            <h2 id="titulo-cargos" class="panel__title">Permisos por cargo</h2>
            @if (institucionales.length === 0) {
                <div class="alert alert-warning">
                    Primero marca una asociación como institucional (arriba): los permisos globales se conceden a los
                    cargos de una asociación institucional concreta.
                </div>
            } @else {
                <div class="form-grid align-items-end mb-3">
                    <div>
                        <label class="form-label" for="asociacion-sel">Asociación institucional</label>
                        <select id="asociacion-sel" class="form-select" [ngModel]="asociacionSeleccionada" (ngModelChange)="cambiarAsociacion($event)">
                            @for (item of institucionales; track item.id) {
                                <option [ngValue]="item.id">{{ item.nombre || ('Asociación #' + item.id) }}</option>
                            }
                        </select>
                    </div>
                    <p class="small text-muted mb-1">
                        Los permisos globales que marques valen para quien ostente el cargo en <strong>esta</strong> asociación.
                        «Solo su asociación» es propio del cargo y vale en la asociación donde se ostente.
                    </p>
                </div>
            }
            @if (cargos.length === 0) {
                <p class="empty-inline">No hay cargos elegibles.</p>
            }
            @for (cargo of cargos; track cargo.id) {
                <article class="cargo" [class.cargo--abierto]="expandidos.has(cargo.id)" [class.cargo--modificado]="modificado(cargo)">
                    <button type="button" class="cargo-cabecera w-100 text-start" (click)="alternar(cargo.id)"
                        [attr.aria-expanded]="expandidos.has(cargo.id)" [attr.aria-controls]="'cargo-' + cargo.id">
                        <div>
                            <strong>{{ cargo.nombre }}</strong>
                            <span class="text-muted small d-block">
                                Titulares vigentes en asociaciones institucionales: {{ cargo.titularesInstitucionales }}
                                · Último cambio: {{ textoUltimoCambio(cargo) }}
                            </span>
                        </div>
                        <span class="d-flex align-items-center gap-2 flex-shrink-0">
                            @if (modificado(cargo)) { <span class="badge text-bg-warning">Sin guardar</span> }
                            <span class="badge text-bg-light">{{ totalConcedidos(cargo) }} permisos</span>
                            <i class="bi" [ngClass]="expandidos.has(cargo.id) ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                        </span>
                    </button>

                    @if (expandidos.has(cargo.id)) {
                        <div class="cargo-cuerpo" [id]="'cargo-' + cargo.id">
                            @for (grupo of porModulo(); track grupo.modulo) {
                                <h3 class="modulo-titulo">{{ grupo.modulo }}</h3>
                                @for (permiso of grupo.permisos; track permiso.codigo) {
                                    <div class="permiso">
                                        <div class="permiso__info">
                                            <code>{{ permiso.codigo }}</code>
                                            <span class="badge ms-2" [ngClass]="'nivel-' + permiso.nivel">{{ etiquetaNivel[permiso.nivel] }}</span>
                                            @if (permiso.sensible) {
                                                <span class="badge text-bg-danger ms-1" title="Pide confirmación y siempre queda auditado"><i class="bi bi-exclamation-triangle-fill me-1" aria-hidden="true"></i>Sensible</span>
                                            }
                                            <span class="d-block small">{{ permiso.descripcion }}</span>
                                            <span class="d-block small text-muted"><i class="bi bi-info-circle me-1" aria-hidden="true"></i>{{ permiso.consecuencia }}</span>
                                        </div>
                                        <div class="permiso__control">
                                            <label class="visually-hidden" [for]="'sel-' + cargo.id + '-' + permiso.codigo">
                                                Alcance de {{ permiso.codigo }} para {{ cargo.nombre }}
                                            </label>
                                            <select class="form-select form-select-sm"
                                                [id]="'sel-' + cargo.id + '-' + permiso.codigo"
                                                [ngModel]="estado(cargo, permiso.codigo)"
                                                (ngModelChange)="cambiar(cargo, permiso.codigo, $event)">
                                                <option value="ninguno">Sin acceso</option>
                                                @if (admiteAsociacion(permiso)) {
                                                    <option value="asociacion">Solo su asociación</option>
                                                }
                                                <option value="global">Global en esta asociación institucional</option>
                                            </select>
                                        </div>
                                    </div>
                                }
                            }
                            <div class="form-actions justify-content-end mt-3">
                                <button type="button" class="btn btn-outline-secondary" [disabled]="!modificado(cargo) || guardando" (click)="descartar(cargo)">Descartar</button>
                                <button type="button" class="btn btn-primary" [disabled]="!modificado(cargo) || guardando" (click)="guardar(cargo)">
                                    {{ guardando ? 'Guardando…' : 'Guardar cambios' }}
                                </button>
                            </div>
                        </div>
                    }
                </article>
            }
        </section>

        <section class="panel" aria-labelledby="titulo-auditoria">
            <h2 class="panel__title mb-0">
                <button type="button" class="btn btn-link p-0 text-decoration-none h5 mb-0 d-inline-flex align-items-center gap-2" id="titulo-auditoria" (click)="alternarAuditoria()" [attr.aria-expanded]="auditoriaAbierta">
                    Registro de cambios y operaciones sensibles <i class="bi" [ngClass]="auditoriaAbierta ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                </button>
            </h2>
            @if (auditoriaAbierta) {
                <div class="table-wrap mt-3" tabindex="0" role="region" aria-label="Registro de auditoría (desplazable)">
                    <table class="table table-sm align-middle">
                        <thead><tr><th scope="col">Fecha</th><th scope="col">Responsable</th><th scope="col">Acción</th><th scope="col">Recurso</th><th scope="col">Resultado</th></tr></thead>
                        <tbody>
                            @for (fila of auditoria; track fila.id) {
                                <tr>
                                    <td>{{ fila.fecha | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                                    <td>{{ fila.actorNombre || (fila.actorTipo + (fila.actorId ? ' #' + fila.actorId : '')) }}</td>
                                    <td>{{ fila.accion }}</td>
                                    <td>{{ fila.recurso }}</td>
                                    <td>{{ fila.resultado }}</td>
                                </tr>
                            } @empty {
                                <tr><td colspan="5" class="text-muted">Sin registros.</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </section>
    }
</div>
